import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap5';

import CreateModal from './Create/Index';

export default function AddClaimButton({ isPossibleAddClaim }) {
  const [show, setShow] = useState(false);

  const renderTooltip = (props) => (
    <Tooltip {...props}>
      There are no members eligible for
      Talent Insurance Claim at this time.
    </Tooltip>
  );

  if (isPossibleAddClaim) {
    return (
      <>
        <Button onClick={() => setShow(true)}>File a Claim</Button>
        <CreateModal show={show} onCloseClick={() => setShow(false)} />
      </>
    );
  }

  return (
    <OverlayTrigger overlay={renderTooltip}>
      <div className="d-inline">
        <Button disabled>File a Claim</Button>
      </div>
    </OverlayTrigger>
  );
}

AddClaimButton.propTypes = {
  isPossibleAddClaim: PropTypes.bool,
};

AddClaimButton.defaultProps = {
  isPossibleAddClaim: false,
};
